import {useEffect, useState} from "react";
import associateServices from "../../../services";
import {useSelector} from "react-redux";
import HomepageCasinoGroupItem from "./item";
import TopGames from "../../../components/top-games";
import MiniGames from "../../../components/mini-games";
import PopularGames from "../../../components/popular-games";
import NewGames from "../../../components/new-games";
import FreeSpinGames from "../../../components/freespin-games";
import HighRtpGames from "../../../components/high-rtp-games";
import JackpotGames from "../../../components/jackpot-games";
import BuyBonusGames from "../../../components/buy-bonus-games";
import InstantWinGames from "../../../components/instant-win-games";
import LiveCasino from "../../../components/live-casino";
import Loading from "../../../components/loading";

const generalGroups = {}
const CasinoLobbyGroups = () => {
    const {activeLanguage} = useSelector(state => state.globalReducer)

    const [groups, setGroups] = useState([])
    const [loading, setLoading] = useState(true)


    useEffect(() => {
        // todo get homepage groups !

        if (generalGroups[activeLanguage.key]) {
            setGroups(generalGroups[activeLanguage.key])
            setLoading(false)

        } else
            associateServices.getCasinoLobbyGameGroups({
                language: activeLanguage?.key,
            }).then(res => {
                setGroups(res?.data || [])
                generalGroups[activeLanguage.key] = res?.data || []
                setLoading(false)
            })
    }, [activeLanguage?.key])


    return (
        <>
            {

                loading ? <Loading/> :
                    groups?.length >= 1 ?
                        groups?.map(group =>
                            <HomepageCasinoGroupItem
                                key={group?.id}
                                path={group?.slug} image={group?.image}
                                title={group?.title} data={group?.group}/>
                        )
                        :

                        <>
                            <TopGames/>

                            <MiniGames/>

                            <PopularGames/>

                            <NewGames/>

                            <FreeSpinGames/>

                            <HighRtpGames/>

                            <JackpotGames/>

                            <BuyBonusGames/>

                            <InstantWinGames/>

                            <LiveCasino/>
                        </>
            }
        </>
    )

}

export default CasinoLobbyGroups
